// extracted by mini-css-extract-plugin
module.exports = {"header":"ff0e7e5c bg-white z-2","headerLinksContainer":"e4e34577 center w-70 flex border-box ph3","logo":"_43e27900 db flex-auto pb2 pt3"};